var map = {
	"./vinhais/default-logo.png": 35155,
	"./vinhais/favicon.png": 35848,
	"./vinhais/footer-logo.png": 72455,
	"./vinhais/logo-1.svg": 89426,
	"./vinhais/logo-2.svg": 98913,
	"./vinhais/logo-3.svg": 63376,
	"./vinhais/logo-header-mobile.svg": 18733,
	"./vinhais/logo-header-tablet.svg": 3523,
	"./vinhais/logo-header.svg": 79374,
	"./vinhais/logo-mobile.svg": 96623,
	"./vinhais/logo.svg": 99996,
	"./vinhais/maskable-icon.png": 69570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38618;